import coreModule from "../core/core-modules";

import renderModule from "../render/render-modules";

import pickModule from "../picker/pick-modules";

import graphicModule from "../graphic/graphic-service/graphic-module";

import pluginModule from "../plugins/plugin-modules";

import loadBuiltinContributions from "../core/contributions/modules";

import loadRenderContributions from "../render/contributions/modules";

import { getLegacyBootstrapState } from "./bootstrap-state";

const legacyBootstrapState = getLegacyBootstrapState(), legacyBindingContext = legacyBootstrapState.legacyBindingContext;

function getLegacyTarget(resolver) {
    let target;
    return () => (void 0 === target && (target = resolver()), target);
}

export function preLoadAllModule() {
    legacyBootstrapState.preloaded || (legacyBootstrapState.preloaded = !0, coreModule({
        bind: legacyBindingContext.bind
    }), graphicModule({
        bind: legacyBindingContext.bind
    }), renderModule({
        bind: legacyBindingContext.bind
    }), pickModule({
        bind: legacyBindingContext.bind,
        isBound: legacyBindingContext.isBound
    }), pluginModule({
        bind: legacyBindingContext.bind
    }), loadBuiltinContributions(legacyBindingContext), loadRenderContributions(legacyBindingContext));
}

export function getLegacyBindingContext() {
    return legacyBindingContext;
}

export function resolveLegacySingleton(serviceIdentifier) {
    preLoadAllModule();
    const [instance] = legacyBindingContext.getAll(serviceIdentifier);
    return instance;
}

export { LEGACY_BOOTSTRAP_STATE_SYMBOL, getLegacyBootstrapState } from "./bootstrap-state";

export function resolveLegacyNamed(serviceIdentifier, name) {
    return preLoadAllModule(), legacyBindingContext.getNamed(serviceIdentifier, name);
}

export function createLegacySingletonProxy(resolver) {
    const getTarget = getLegacyTarget(resolver);
    return new Proxy({}, {
        get(_target, property) {
            const value = getTarget()[property];
            return "function" == typeof value ? value.bind(getTarget()) : value;
        },
        set: (_target, property, value) => (getTarget()[property] = value, !0),
        has: (_target, property) => property in getTarget(),
        ownKeys: () => Reflect.ownKeys(getTarget()),
        getOwnPropertyDescriptor(_target, property) {
            const descriptor = Object.getOwnPropertyDescriptor(getTarget(), property);
            if (descriptor) return Object.assign(Object.assign({}, descriptor), {
                configurable: !0
            });
        }
    });
}
//# sourceMappingURL=bootstrap.js.map
